import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Input,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import moment from 'moment';
import SaveIcon from '@material-ui/icons/Save';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import LoopIcon from '@material-ui/icons/Loop';
import Controls from '../controls/Controls';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';

/* eslint-disable camelcase */
function SsbCodesSub(props) {
  const { closePopup } = props;
  const [errors, setErrors] = useState('');
  const [ssbCodeData, setSsbCode] = useState({
    payeeCode: '',
    adCode: '',
    ssbCompanyName: '',
    active: true
  });
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  const SsbLineSchema = Yup.object().shape({
    ssbCompanyName: Yup.string().required('Company name is required'),
    payeeCode: Yup.string()
      .required('you must specify the SSB Code #')
      .matches(/^[0-9]+$/, 'SSB Code # Must be only digits')
      .min(5, 'SSB Code should be 5 Charecters ')
      .min(5, 'Ad Code should be 5 Charecters'),
    adCode: Yup.string()
      .required('you must specify the AD Code #')
      .matches(/^[0-9]+$/, 'AD Code # Must be only digits')
      .min(4, 'Ad Code should be 4 Charecters ')
      .max(4, 'Ad Code should be 4 Charecters')
  });

  const formik = useFormik({
    initialValues: ssbCodeData,
    enableReinitialize: true,
    validationSchema: SsbLineSchema,
    onSubmit: (values) => {
      console.log('claim line details ', values);
      saveCycle(values);
    }
  });

  //   useEffect(() => {
  //     if (currentCycleId > 0) {
  //       getCycle(currentCycleId);
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [currentCycleId]);

  const saveCycle = (line) => {
    const jsonClient = [];
    jsonClient.push(line);
    console.log('SaveSsb b4 save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/ssb/SaveSsbCode`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          notifyPopup(`SSB Code Saved Successfully!`, 'success');
          navigate(`/`);
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving SSB Code!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleMouseDownPassword = (event) => {
    console.log('mouse down');
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box>
            <Typography color="error" variant="h6">
              {errors && <div>{errors}</div>}
            </Typography>
          </Box>
          <Grid item xs={12} sm={4} ml={12}>
            <Controls.Input name="payeeCode" label="SSB Code" />
          </Grid>
          <Grid item xs={12} sm={10} ml={12}>
            <Controls.Input name="adCode" label="AD Code" />
          </Grid>
          <Grid item xs={12} sm={10} ml={12}>
            <Controls.Input name="ssbCompanyName" label="Company" />
          </Grid>

          {/* <Grid item xs={12} sm={3}>
            <Button
              type="button"
              variant="outlined"
              startIcon={<DirectionsRunIcon />}
              disabled={formik.values.selfPmts}
              // onClick={() => runSelfPaymentClaims()}
            >
              Run...
            </Button>
          </Grid> */}
          <Grid
            marginRight={4}
            container
            direction="row"
            justifyContent="right"
            alignItems="right"
            paddingRight={2}
          >
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                disabled={ssbCodeData.payeeCode !== ''}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default SsbCodesSub;
